import usePageTracking from "./UsePageTracking";

interface IGAWrapperProps {
    children: React.ReactNode;
}

export default function GAWrapper(props: IGAWrapperProps) {
    const { children } = props;
    usePageTracking();
    
    return (
        <>
            {children}
        </>
    );
}